import { EnvironmentUrls } from 'Roblox';

export const newParentalRequest = `${EnvironmentUrls.apiGatewayUrl}/child-requests-api/v1/send-request-to-new-parent`;
export const broadcastParentalRequest = `${EnvironmentUrls.apiGatewayUrl}/child-requests-api/v1/send-request-to-all-parents`;
export const parentEmailUrl = `${EnvironmentUrls.userSettingsApi}/v1/account-insights/parent-emails`;
